<template>

    <form ref="colaboradorlogacesso-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">

            
					<div class="form-group col-md-12">
                        <label for="colaboradorId">ColaboradorId</label>
                        <input type="text" class="form-control" name="colaboradorId" placeholder="ColaboradorId" v-model="model.colaboradorId" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="escolaId">EscolaId</label>
                        <input type="text" class="form-control" name="escolaId" placeholder="EscolaId" v-model="model.escolaId" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="email">Email</label>
                        <input type="text" class="form-control" name="email" placeholder="Email" v-model="model.email" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="dataLogin">DataLogin</label>
                        <input type="text" v-datepicker class="form-control" name="dataLogin" v-model="model.dataLogin" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="dataLogoff">DataLogoff</label>
                        <input type="text" v-datepicker class="form-control" name="dataLogoff" v-model="model.dataLogoff"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="ipAcesso">IpAcesso</label>
                        <input type="text" class="form-control" name="ipAcesso" placeholder="IpAcesso" v-model="model.ipAcesso"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="localizacao">Localizacao</label>
                        <input type="text" class="form-control" name="localizacao" placeholder="Localizacao" v-model="model.localizacao"  />
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "colaboradorlogacesso-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "colaboradorlogacesso-form-edit",
            
            resources: {
                edit: 'colaboradorlogacesso',
            },

        }),
		
        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false)return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ colaboradorLogAcessoId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>